module.exports = __webpack_public_path__ + "routes/urzad/images/waiting-wheel-300x300.gif?04fcf026";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/images/waiting-wheel-300x300.gif
// module id = 1759
// module chunks = 0